export { RatingsPieChart, RatingsPieChartProps } from './RatingsPieChart';
